import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserPaymentService} from '@spartacus/core';
import {DelegoRapidpayService} from '../../services/delego-rapidpay/delego-rapidpay.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'dcp-delego-add-new-cc',
  templateUrl: './delego-add-new-cc.component.html',
  styleUrls: ['./delego-add-new-cc.component.scss']
})
export class DelegoAddNewCcComponent implements OnInit, OnDestroy {
  @Input() isClosable: boolean = false;
  displayComponent = false;
  isLoading = true;

  constructor(
    private userPaymentService: UserPaymentService,
    private delegoRapidpayService: DelegoRapidpayService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.delegoRapidpayService.isAddNewCreditCardComponentOpened().pipe(untilDestroyed(this)).subscribe(isOpen => {
      this.displayComponent = isOpen;
      this.cdr.detectChanges();
    });

    this.delegoRapidpayService.isDelegoLoading().pipe(untilDestroyed(this)).subscribe(value => {
      this.isLoading = value;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.delegoRapidpayService.destroyIFrame();
  }

  public closeDelegoRapidPayIFrame(): void {
    this.userPaymentService.loadPaymentMethods();
    this.delegoRapidpayService.closeAddNewCreditCardComponent();
  }

  isNeedToShowCloseButton(): Observable<boolean> {
    return this.delegoRapidpayService.isAddNewCreditCardComponentOpened().pipe(map(isAddNewCreditCardComponentOpened =>
      this.isClosable && isAddNewCreditCardComponentOpened));
  }
}
